import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
const PURCHASES = [{
  name: 'Matías',
  city: 'Córdoba'
}, {
  name: 'Lucas',
  city: 'CABA'
}, {
  name: 'Federico',
  city: 'Rosario'
}, {
  name: 'Tomás',
  city: 'Mendoza'
}, {
  name: 'Agustín',
  city: 'La Plata'
}, {
  name: 'Ignacio',
  city: 'Mar del Plata'
}, {
  name: 'Facundo',
  city: 'Neuquén'
}, {
  name: 'Martín',
  city: 'Tucumán'
}];
export function PurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Interval for subsequent popups
    const intervalTimer = setInterval(() => {
      showPopup();
    }, 15000 + Math.random() * 10000); // Random interval between 15-25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-250" data-mp="n6born0sr5ir">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-zinc-900 border border-zinc-800 rounded-lg p-3 shadow-2xl z-50 flex items-center gap-3" data-id="element-251" data-mp="n7d9ykbj18e7">
          <div className="bg-[#c6ff2e]/20 p-2 rounded-full" data-id="element-252" data-mp="23nhc88smhozm">
            <MapPin className="w-5 h-5 text-[#c6ff2e]" data-id="element-253" data-mp="2anjk7ifq4d8v" />
          </div>
          <div data-id="element-254" data-mp="2fnec9pb8j8vi">
            <p className="text-sm text-zinc-300" data-id="element-255" data-mp="2fmv1qtnwzmri">
              <span className="font-bold text-white" data-id="element-256" data-mp="2fpqxqcg7c1db">
                {currentPurchase.name}
              </span>{' '}
              de {currentPurchase.city}
            </p>
            <p className="text-xs text-[#c6ff2e] font-medium" data-id="element-257" data-mp="2plbwm1pz4liu">
              Acaba de comprar el manual
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}